import { useMemo } from 'react';

import { emptyStructuredPromptManifest } from '@/Pages/HubPlayground/HubPlayground.utils';
import {
  createPlaygroundManifest,
  defaultChatModelManifest,
} from '@/Pages/Playground/utils/Playground.utils';
import { parseOwnerRepoCommit } from '@/components/Rules/RulesEvaluatorPane.utils';
import { useCommit } from '@/hooks/useSwr';

import { useEvaluatorStore } from '../store/evaluatorStore';

export function useHubTypeManifest() {
  const hubRef = useEvaluatorStore((state) => state.hubRef);
  const evaluatorVersion = useEvaluatorStore((state) => state.evaluatorVersion);

  const [owner, promptName, commitHash] = hubRef
    ? parseOwnerRepoCommit(hubRef)
    : [];

  const { data: commitData, isLoading: commitIsLoading } = useCommit({
    owner,
    repo: promptName ?? '',
    sha: commitHash ?? 'latest',
    get_examples: false,
    include_model: evaluatorVersion >= 3,
    options: {
      revalidateOnFocus: false,
      dedupingInterval: 0,
      keepPreviousData: false,
    },
  });

  const manifest = useMemo(() => {
    // Prioritize model from commitData (hub), fall back to store model, then default
    const modelToUse =
      commitData?.manifest?.kwargs?.last ?? defaultChatModelManifest;

    return createPlaygroundManifest(
      (evaluatorVersion >= 3
        ? commitData?.manifest?.kwargs?.first
        : commitData?.manifest) ??
        emptyStructuredPromptManifest('dataset-eval', null, 'mustache'),
      modelToUse
    );
  }, [commitData, evaluatorVersion]);

  return { manifest, isLoading: commitIsLoading };
}
